import React from "react";
import { iconsDetailsProyect } from "../../assets/icons/detailsProject";

export const ContainerModal = ({
    className = "",
    children,
    title = "",
    isNecesaryIcon = true,
    icon = iconsDetailsProyect.close,
    actionButton = () => { },
}) => {
    return (
        <div className={`p-4 rounded-[4px] bg-white flex flex-col gap-4  ${className}  overflow-scroll	`}>
            <div className="w-full h-[20px] flex items-center justify-between">
                <p className="font-semibold">{title}</p>
                {isNecesaryIcon && (
                    <div onClick={actionButton} className="h-full w-[20px] cursor-pointer">
                        <img className="h-full w-full object-contain" src={icon} alt="icon" />
                    </div>
                )}
            </div>
            {children}
        </div>
    );
};
